import React from 'react';
import { Flip } from 'react-reveal';
import { ProjectsData } from '../data';
import img1 from '../assets/intro.jpg'
import chb from '../assets/chb.webp'
import chb_landing from '../assets/chb-landing.webp'
import vid from '../assets/app.MOV'
import { ArrowCircleDown } from '@mui/icons-material';
// import Contact from './Contact';
import { Fade } from 'react-reveal';

function Projects(props) {
const handleDownload = () => {
    window.open(
        "https://play.google.com/store/apps/details?id=com.cyberwolf.codes&pli=1",
        "_blank"
    );
};

    return (
        <div className='projects-page mt-5' id='projects'>
            <br />
            <h6 className='ms-3 fw-bold'>MY PROJECTS</h6>
            <p style={{ fontSize: '14px', marginTop: '5px', marginLeft: '12px' }}>
                The following are growing projects by yours truly...
            </p>
            <div className='mt-4 projects'>
                {ProjectsData.map((project, index) => (
                    <section className='project-con shadow-lg rounded' key={index}>
                        <center className='gray'>
                            <div className=" fw-bold project-name ">{project.name}</div>
                            <small className='project_description'>{project.description}
                                <div>
                                    <a href={project.url} target='_blank' style={{ textDecoration: 'none' }}>
                                        <button className="btn1" type="button">
                                            <strong>VISIT</strong>
                                            <div id="container-stars">
                                                <div id="stars"></div>
                                            </div>

                                            <div id="glow">
                                                <div className="circle"></div>
                                                <div className="circle"></div>
                                            </div>
                                        </button>
                                    </a>
                                </div>

                            </small>
                            <Fade bottom duration={1000}>
                                <div className='mt-2 '>
                                    <img src={project.image} alt="..." className='img-fluid rounded px-1  project-img' />
                                </div>
                            </Fade>
                        </center>
                        <br />
                        <br />
                    </section>
                ))}
            </div>
            <center className='gray py-4'>
                <div className="appPreview">
                    <span >
                        MOBILE APPS
                    </span>
                </div>
                <div className='apps'>
                    <div className='mt-4' id='app'>
                        <div className='mb-2'>
                            Personal project
                        </div>
                        <video width='270'
                            controls
                            loop
                            webkitallowfullscreen
                            allowfullscreen
                            poster={img1}
                        >
                            <source src={vid} />
                        </video>
                    </div>

                    <div>
                        <div className='mb-2'>
                            Live project
                        </div>
                        <div className='smaller'>
                            (Available on google play store)
                        </div>
                        <button className="btn1" type="button" onClick={handleDownload}>
                            <strong className='smaller'>DOWNLOAD</strong>
                            <div id="container-stars">
                                <div id="stars"></div>
                            </div>

                            <div id="glow">
                                <div className="circle"></div>
                                <div className="circle"></div>
                            </div>
                        </button>
                        <img src={chb_landing} alt="" />
                    </div>
                </div>
            </center>

        </div>
    );
}

export default Projects;